import { formatDate } from 'shared/utils/formatDate'

export const EXPRESS_SLA_ID = 'Despacho Express'

export interface ShipmentWindow {
  endDateUtc?: string
  id?: string
  price?: number | string
  startDateUtc?: string
}

export interface ShipmentWindowSummary {
  isExpress: boolean
  priceText: string
  text: string
}

export interface PreviewWindow {
  end?: string
  id?: string
  price?: number | string
  start?: string
}

export const getFirstSimulationWindow = (response?: {
  previewWindow?: PreviewWindow
}): ShipmentWindow | null => {
  const previewWindow = response?.previewWindow

  if (!previewWindow?.start || !previewWindow?.end || !previewWindow?.id) {
    return null
  }

  return {
    endDateUtc: previewWindow.end,
    id: previewWindow.id,
    price: previewWindow.price,
    startDateUtc: previewWindow.start
  }
}

const formatPrice = (price?: number | string): string => {
  const normalizedPrice =
    typeof price === 'number'
      ? price
      : Number(price?.replace(/[^\d-]/g, '') || Number.NaN)

  if (!Number.isFinite(normalizedPrice) || normalizedPrice === 0) {
    return 'Gratis'
  }

  return `$${normalizedPrice.toLocaleString('es-CL')}`
}

const isSameDate = (firstDate: Date, secondDate: Date): boolean => {
  return (
    firstDate.getFullYear() === secondDate.getFullYear() &&
    firstDate.getMonth() === secondDate.getMonth() &&
    firstDate.getDate() === secondDate.getDate()
  )
}

export const formatShipmentWindow = (
  shipmentWindow?: ShipmentWindow,
  currentDate = new Date()
): ShipmentWindowSummary | null => {
  if (!shipmentWindow?.startDateUtc || !shipmentWindow?.endDateUtc) return null

  const startDate = new Date(shipmentWindow.startDateUtc)
  const { day, hourMinutes24, month, shortDayName } = formatDate({
    date: shipmentWindow.endDateUtc
  })
  const dayText = isSameDate(startDate, currentDate)
    ? 'Hoy'
    : `${
        shortDayName.charAt(0).toUpperCase() + shortDayName.slice(1)
      } ${day}/${month}`
  const priceText = formatPrice(shipmentWindow.price)

  return {
    isExpress: shipmentWindow.id === EXPRESS_SLA_ID,
    priceText,
    text: `${dayText}, antes de las ${hourMinutes24} - ${priceText}`
  }
}
